<h2>Spell Slots</h2>
<mat-tab-group>
  @for (spellGroup of block.getMemorizedSpells(); track spellGroup) {
    <mat-tab label="Level {{spellGroup.level}}">
      <mat-list cdkDropList (cdkDropListDropped)="drop($event, spellGroup)" [cdkDropListData]="spellGroup.spells">
        @for (spell of spellGroup.spells; track spell; let j = $index) {
          <mat-list-item cdkDrag>
            Slot {{j + 1}}:&nbsp;
            @if (spell) {
              <div matTooltip="{{spell.description}}">{{spell.name}} (Level {{spell.level}})
                <button mat-icon-button color="warn" class="use-spell-button" (click)="removeSpell(spellGroup,j)" aria-label="Use spell">
                  <mat-icon>remove</mat-icon>
                </button>
              </div>
            }
            <mat-divider></mat-divider>
          </mat-list-item>
        }
      </mat-list>
    </mat-tab>
  }
</mat-tab-group>

